<template>
  <div>
    <div style="margin-bottom: 20px; height: 30px">
      <!-- <el-button plain @click="showVariationsTable = false">Close</el-button> -->

            <el-form
              :model="formdata"
              status-icon
              ref="formdata"
              label-width="120px"
              :label-position="labelPosition"
              size="medium"
              style="
                <!-- border: 1px solid #e2e2e2;
                border-radius: 5px; -->
                background-color: #fff;
                padding: 25px;
              "
            >
              <el-form-item
                label="Customer Name"
                prop="name"
                :rules="[
                  { required: true, message: 'Customer name', trigger: 'blur' },
                ]"
              >
                <el-input placeholder="Name" v-model="formdata.name"></el-input>
              </el-form-item>

              <el-form-item
                label="Telephone Without 0"
                prop="tel"
                :rules="[
                  { required: true, message: 'Telephone' },
                  { type: 'number', message: 'Telephone no must be a number' },
                ]"
              >
                <el-input
                  v-model.number="formdata.tel"
                  auto-complete="off"
                  placeholder="Telephone"
                ></el-input>
              </el-form-item>

              <el-form-item
                v-if="$route.name === 'jobNotes'"
                label="Device"
                prop="device"
                :rules="[
                  { required: true, message: 'Device', trigger: 'blur' },
                ]"
              >
                <el-input
                  placeholder="Device"
                  v-model="formdata.device"
                ></el-input>
              </el-form-item>

              <el-form-item
                v-if="$route.name === 'jobNotes'"
                label="Technician"
                prop="techId"
                :rules="[
                  { required: true, message: 'User role', trigger: 'change' },
                ]"
              >
                <el-select
                  v-model="formdata.techName"
                  placeholder="Technician"
                  @change="(value) => {
                    formdata.techId = value.sysid
                    formdata.techName = value.name}"
                >
                  <el-option
                  v-for="item in users.filter(user => user.role === 'Technician')"
                  :key="item.sysid"
                  :label="item.name"
                  :value="item"
                >
                </el-option>

                </el-select>
              </el-form-item>

              <el-form-item
                label="Advanced Payment"
                prop="tel"
                :rules="[
                  { required: true, message: 'Advanced Payment' },
                  { type: 'number', message: 'Advanced Payment must be a number' },
                ]"
              >
                <el-input
                  v-model.number="formdata.adv"
                  auto-complete="off"
                  placeholder="Advanced Payment"
                ></el-input>
              </el-form-item>

               <el-form-item
                label="Status"
                prop="status"
                :rules="[
                  { required: true, message: 'Status', trigger: 'change' },
                ]"
              >
                <el-select
                  v-model="formdata.status"
                  placeholder="Status"
                  @change="(value) => formdata.status = value"
                >
                  <el-option value="Pending">Pending</el-option>
                  <el-option value="Working">Working</el-option>
                  <el-option value="Completed">Completed</el-option>

                </el-select>
              </el-form-item>
               <el-form-item label="Notes" prop="note">
              <el-input type="textarea" v-model="formdata.note"></el-input>
            </el-form-item>
            </el-form>

    <h6 class="text-info text-center pt-2 mb-3">{{$route.name === 'jobNotes'? 'Add require items for job' : 'Add items for order'}}</h6>
      <el-autocomplete size="medium" style="
                    margin-bottom: 1px;
                    border: 1px solid #409eff;
                    border-radius: 5px;
                    width: 100%;
                  " popper-class="my-autocomplete" v-model="itemName" :fetch-suggestions="querySearch"
        placeholder="Search Item" @select="handleProductChange">
        <i class="el-icon-edit el-input__icon" slot="suffix"> </i>
        <template slot-scope="{ item }">
          <div class="link">{{ item.name }}</div>
          <span class="value">SKU: {{ item.barcode }}</span>
        </template>
      </el-autocomplete>

    <el-button @click="innerVisible=true" size="medium" style="width:100%" type="primary">View Items</el-button>
    <h6 class="text-info text-center pt-4 ">{{$route.name === 'jobNotes'?'Required items for job' : 'Ordered items' }}</h6>
    <el-table ref="singleTable" :data="jobItemData" highlight-current-row style="
           {
            overflow-x: scroll;
            width: 800px;
            margin: 0 auto;
          }
        ">
      <el-table-column type="index" width="50"> </el-table-column>

      <el-table-column width="150" property="serial" label="Item">
        <template slot-scope="scope">
          <el-input size="mini" v-model="scope.row.item"></el-input>
        </template>
      </el-table-column>
      <el-table-column width="150" property="quantity" label="Quantity">
        <template slot-scope="scope">
          <el-input-number size="mini" :precision="2" :min="0" v-model="scope.row.quantity"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column width="150" label="Operations">
        <template slot-scope="scope">
          <el-button size="small" @click="open(scope.$index, scope.row)" type="danger" icon="el-icon-delete"
            circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px 0px; height: 50px">
     <el-button
      :disabled="disabled"
        size="medium"
        style="float: right; margin-right: 0px"
        v-if="store && store !== 'all'"
        type="success"
        @click="savejob(method, jobid)"
        >Save</el-button
      >
    </div>
      <el-dialog
        width="80%"
        title="Items"
        :visible.sync="innerVisible"
        append-to-body>
        <el-row>
          <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6" v-for="(item, index) in allProducts" :key="index">
            <el-card :body-style="{ padding: '0px' }">
              <img :src="item.img" class="image">
              <div style="padding: 4px 14px">
                {{ item.name }}
                <el-button @click="handleProductChange(item)" style="padding-top: 4px; display: block;" type="text">Add Item</el-button>

              </div>
            </el-card>
          </el-col>
        </el-row>
    </el-dialog>

    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import { bus } from "../../main";
export default {
  name: "VariationsTable",
  props: ["jobItemData","jobData","method","jobid", "allProducts", 'users'],
  data() {
    return {
      currentRow: null,
      store: this.$store.state.selectedStore,
      tableData: [],
      stores: [
        { id: "all", value: "all", label: "All Stores" },
        ...this.$store.state.stores,
      ],
      prdNameList: this.$store.state.allProducts,
      itemName:'',
      table:"",
      note:"",
      disabled: false,
      innerVisible:false,
      formdata: {
        name: "",
        tel: "",
        id: "",
        device: "",
        status: "Pending",
        user: "",
        items: [],
        note: "",
        techId: '',
        techName: '',
        adv: 0,
      },
      type: this.$route.name === 'jobNotes' ? 'job' : 'order',
      labelPosition: "top",
    };
  },
  created() {
    this.tableData = this.jobItemData;
    this.jobData ? this.formdata = this.jobData : ''
  },

  mounted() {
    bus.$on("dialogClosed", (data) => {
      console.log('dialogClosed')
      this.formdata = {
        name: "",
        tel: "",
        id: "",
        device: "",
        status: "",
        user: "",
        items: [],
        note: "",
        techId: '',
        techName: '',
        adv: 0,
      }
    })
    bus.$on("dialogOpen", (data) => {
      console.log('dialogOpen')
      this.formdata = data
    })
  },

  methods: {
    savejob(method, jobid) {
      const saveType = this.$route.name === 'jobNotes' ? 'jobSaved' : 'orderSaved'
      if (method === 'create') {
        this.disabled = true
        const jobData = {
          note: this.formdata.note,
          name: this.formdata.name,
          device: this.formdata.device,
          tel: this.formdata.tel,
          items: [...this.jobItemData],
          status: 'Pending',
          store: this.$store.state.selectedStore,
          techId: this.formdata.techId,
          techName: this.formdata.techName,
          adv: this.formdata.adv,
          type: this.type,
          date: firebase.firestore.Timestamp.now(),
          jobNo: Math.floor(Math.random() * 100000001).toString(),
          updated: firebase.firestore.Timestamp.now(),
          user: this.$store.state.systemUser.id,
          createdBy: this.$store.state.systemUser.name,
          shopOwner: firebase.auth().currentUser.uid,
        }
        this.$store.state.secondaryDatabase
          .collection("job")
          .add(jobData)
          .then((doc) => {
            this.formdata = {};
            console.log("saveType",saveType)
            bus.$emit(saveType, {...jobData, id: doc.id});
            this.jobItemData.splice(0,this.jobItemData.length);
            this.$notify({
              title: "Success",
              message: "job created",
              type: "success",
            });
            this.disabled = false
            // this.loading1 = false;
            // this.changed = true;
          })
          .catch((error) => alert(error));
      }
      if (method === 'update') {
        // this.cashData.forEach((item) => (item.date = new Date(item.date)));
        this.$store.state.secondaryDatabase
          .collection("job")
          .doc(jobid)
          .update({
            note: this.formdata.note,
            name: this.formdata.name,
            device: this.formdata.device,
            tel: this.formdata.tel,
            items: this.jobItemData,
            status: this.formdata.status,
            adv: this.formdata.adv,
            updated: firebase.firestore.Timestamp.now(),
            updatedBy: this.$store.state.systemUser.name,
          })
          .then((doc) => {
            // this.$store.state.secondaryDatabase
            //   .collection("shops")
            //   .doc(this.shops[0].id)
            //   .update({
            //     curSales: 0,
            //   })
            //   .then((doc) => {

            //   });
            bus.$emit(saveType, {});
            this.$notify({
              title: "Success",
              message: "job updated",
              type: "success",
            });
            // this.loading1 = false;
            // this.changed = true;
          })
          .catch((error) => alert(error));
      }
    },
    updatePriceData(store) {
      // this.tableData = this.jobItemData;
      // this.tableData = this.tableData.filter((data) => data.store === store);
      console.log(this.jobItemData, this.tableData);
    },

    querySearch(queryString, cb) {
      var prds = this.prdNameList;
      var results = queryString
        ? prds.filter(this.createFilter(queryString))
        : [];
      // call callback function to return suggestion objects
      cb(results);
    },

    createFilter(queryString) {
      return (prd) => {
        return (
          prd.name.toLowerCase().includes(queryString.toLowerCase()) ||
          prd.barcode.toLowerCase().includes(queryString.toLowerCase())
        );
      };
    },

    handleProductChange(item) {
      this.itemName = item.name
      const foundItem = this.jobItemData.find(
          (product) =>
            product.barcode === item.barcode &&
            product.item === item.name
        );
      if (foundItem) {
        foundItem.quantity ++
      }else {
          this.jobItemData.push({
          item: item.name,
          barcode: item.barcode,
          quantity: 1,
          cat: item.category
        });
      }

      this.itemName = ''
      console.log(this.jobItemData, this.tableData);
    },
    handleDelete(index, row) {
      const foundIndex = this.jobItemData.findIndex(
        (pr) =>
          pr.name === row.name &&
          pr.barcode === row.barcode &&
          pr.quantity === row.quantity
      );
      this.jobItemData.splice(foundIndex, 1);
      console.log(this.jobItemData, this.tableData);
    },
    open(index, row) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.handleDelete(index, row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
  },
};
</script>

<style scoped>
  .image {
    width: 100%;
    display: block;
    min-height: 227.3px;
    max-height: 227.3px
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/JobNoteDialog.vue